import LinkIcon from '@atlaskit/icon/core/link';
import React from 'react';
import { type HyperlinkItemContent } from './hyperlink-read-content.ts';
import styles from './hyperlink-value-view.module.css';

/**
 * V1's non-resolving/failure anchor displays the URL; its loading/plain wrapper
 * retains the best-known label and icon. Keep those two fallbacks distinct.
 */
export function HyperlinkPlaceholder({
  link,
  asLink = false,
  showDisabledValue = false,
  noFocus = false,
  showIcon = true
}: {
  readonly link: HyperlinkItemContent;
  readonly asLink?: boolean;
  readonly showDisabledValue?: boolean;
  readonly noFocus?: boolean;
  readonly showIcon?: boolean;
}) {
  const disabled = showDisabledValue || undefined;

  return asLink ? (
    <a
      className={styles.placeholder}
      data-disabled={disabled}
      href={link.href}
      target="_blank"
      rel="noopener noreferrer"
      tabIndex={noFocus ? -1 : undefined}
    >
      <span className={styles.text}>{link.href}</span>
    </a>
  ) : (
    <span className={styles.placeholder} data-disabled={disabled}>
      {showIcon && link.url ? (
        <span className={styles.icon}>
          <LinkIcon label="" />
        </span>
      ) : null}
      <span className={styles.text}>{link.label}</span>
    </span>
  );
}
